import { PhotoIcon } from '@heroicons/react/24/outline';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Chip,
} from '@material-tailwind/react';
import React from 'react';
import { numberWithCommas } from '../../../../../api/utils/format/numbers';
import TextWinds from '../../../../common/TextWinds';
import { Link } from 'react-router-dom';
import { BoostUpTypes } from '../../../../../constants/types';
import { current } from '@reduxjs/toolkit';

interface BoostupCardProps {
  data: BoostUpTypes;
  classId: string;
}
const BoostupCard = ({
  data: {
    id,
    name,
    origin_price,
    current_price,
    thumbnail,
    product_type,
    goods_type,
  },
  classId,
}: BoostupCardProps) => {
  const handleNewTabs = (path: string) => {
    window.open(path, '_blank');
  };

  return (
    <>
      <Card className="shadow-card">
        <Button
          className="h-full w-full rounded-xl border border-gray2 bg-white p-0 shadow-none hover:border-purple2"
          onClick={() => {
            if (product_type === 'COURSE') {
              if (goods_type === 'DIGITAL') {
                handleNewTabs(
                  `${process.env.REACT_APP_JEBS_APP_URL}/courses/homeschool/details/${id}?option=false`,
                );
              } else if (goods_type === 'GOOD') {
                handleNewTabs(
                  `${process.env.REACT_APP_JEBS_APP_URL}/courses/homeschool/details/${id}?option=true`,
                );
              } else {
                return;
              }
            } else {
              handleNewTabs(`./boostup/detail/${id}`);
            }
          }}
        >
          <div className="flex h-full w-full flex-col">
            <CardHeader className="m-0 aspect-square rounded-none rounded-t-xl p-0 shadow-none">
              <img
                className="h-full w-full object-cover"
                src={thumbnail.access_url}
                alt={name}
              />
            </CardHeader>

            <CardBody className="flex flex-1 flex-col p-2">
              <div className="min-h-[42px]">
                <TextWinds
                  type="content_body3"
                  color="gray8"
                  className="line-clamp-2 w-full text-left leading-snug"
                >
                  {name}
                </TextWinds>
              </div>

              <div className="mt-auto pt-2">
                <div className="flex flex-row items-center justify-end">
                  <TextWinds type="content_body3" className="font-bold">
                    {numberWithCommas(current_price)}
                  </TextWinds>
                  <TextWinds type="content_body4">원</TextWinds>
                </div>

                <div className="flex flex-row items-center justify-end">
                  <TextWinds
                    type="caption2"
                    color="gray6"
                    className="line-through"
                  >
                    {numberWithCommas(origin_price)}
                  </TextWinds>
                  <TextWinds type="caption2" color="gray6">
                    원
                  </TextWinds>
                </div>
              </div>
            </CardBody>
          </div>
        </Button>
      </Card>
    </>
  );
};

export default BoostupCard;
